import { oneOf, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
import { enumValues } from '@philips-internal/oswald-ui-utils';
import { AnalyticsProvider } from './analytics-constants.js';
const AnalyticsProperties = {
    id: {
        type: string,
    },
    provider: {
        type: oneOf(['', ...enumValues(AnalyticsProvider)]),
    },
};
export { AnalyticsProperties, };
//# sourceMappingURL=analytics-types.js.map